import { render, staticRenderFns } from "./app.vue?vue&type=template&id=c1268edc&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./app.vue?vue&type=style&index=1&id=c1268edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1268edc",
  null
  
)

export default component.exports